import { render, staticRenderFns } from "./purchase_return_confirm.vue?vue&type=template&id=37f352d2&scoped=true"
import script from "./purchase_return_confirm.vue?vue&type=script&lang=js"
export * from "./purchase_return_confirm.vue?vue&type=script&lang=js"
import style0 from "./purchase_return_confirm.vue?vue&type=style&index=0&id=37f352d2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f352d2",
  null
  
)

export default component.exports